import React, { Component } from "react"

/* Constants */
import { utils, closed, env } from '../constants'

/* Picture */
import { Card } from "../components"
import { CHOICE } from "../constants/status"

/* Widget Dealer Cards */
class DealerCards extends Component {


    helper = (game) => {

        const bust = game && game.score[0] && game.score[0] > 21

        return (
            <div className="dealer-box-helper">
                {
                    bust ?
                        <p className="bust">BUST</p>
                        : null
                }
            </div>
        )

    }

    render = () => {

        const { dealerData } = this.props
        const { status, cards, dealerGame } = dealerData

        let dealerCards = utils.get_unique_values(cards, "uuid")

        let style = ''

        style += status === CHOICE ? "game-choice" : "status-game"

        let marginLeft = 0

        let cardsWidth = dealerCards.length * 74

        if (dealerCards.length > 6) {
            cardsWidth = dealerCards.length * 37 + 37
        }

        let isBlackjack = false

        let score = ''
        dealerGame && dealerGame.score && dealerGame.score.forEach((item, index) => {
            if (!index) {
                score += item
                if (parseInt(item) === 21 && dealerCards.length === 2) {
                    isBlackjack = true
                }
            } else {
                score += `/${item}`
            }
        })

        let scoreStyle = ""

        if (score.length > 4) {
            scoreStyle = "smaller"
        } else if (score.length > 2) {
            scoreStyle = "small"
        }

        return (
            <div className={`dealer-container ${style}`}>

                <div className={`dealer-cards ${style}`} style={{ width: cardsWidth }}>

                    {
                        isBlackjack ?
                            <img className="bj-icon" src={`${env.endpoint}/images/bj-icon.png`} alt="bj" />
                            :
                            dealerGame ?
                                <div className={`dealer-box-inform ${scoreStyle}`}>
                                    <p>{score}</p>
                                </div>
                                : null
                    }

                    {this.helper(dealerGame)}

                    {dealerCards.map((card, index) => {

                        if (dealerCards.length > 6 && index !== 0) {
                            marginLeft = -37
                        }

                        const status = card.id || index === 0 ? true : false

                        const key = card.uuid

                        return (
                            <div className={`dealer-card`} key={`d-${key}`} style={{ marginLeft }}>
                                <div className={`dealer-flip-card  ${status ? 'open' : 'hidden'}`}>
                                    <div className="dealer-flip-card-inner">
                                        <div className="dealer-flip-card-front">
                                            <img src={closed.image} alt="Closed" />
                                        </div>
                                        <div className={`dealer-flip-card-back`}>
                                            {status ? <Card data={card.name} /> : <img src={closed.image} alt="Closed" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                    })}

                </div>

            </div>
        )
    }

}

export default DealerCards